import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-4xl font-bold mb-6">Privacy Policy</h1>
        <p className="mb-4">
          At Payrendr, we take your privacy seriously. This Privacy Policy explains how we collect, use, and protect your information.
        </p>
        <h2 className="text-2xl font-semibold mt-6 mb-4">1. Information Collection</h2>
        <p className="mb-4">
          We collect information that you provide directly to us, such as when you create an account, or via the use of our services.
        </p>
        <h2 className="text-2xl font-semibold mt-6 mb-4">2. Use of Information</h2>
        <p className="mb-4">
          Your information is used to provide and improve our services, communicate with you, and personalize your experience.
        </p>
        <h2 className="text-2xl font-semibold mt-6 mb-4">3. Information Sharing</h2>
        <p className="mb-4">
          We do not share your personal information with third parties except as necessary to provide our services or as required by law.
        </p>
        <h2 className="text-2xl font-semibold mt-6 mb-4">4. Security</h2>
        <p className="mb-4">
          We implement a variety of security measures to maintain the safety of your personal information.
        </p>
        <h2 className="text-2xl font-semibold mt-6 mb-4">5. Changes to This Policy</h2>
        <p className="mb-4">
          We may update our Privacy Policy from time to time. Any changes will be posted on this page.
        </p>
        <h2 className="text-2xl font-semibold mt-6 mb-4">6. Contact Us</h2>
        <p className="mb-4">
          If you have any questions about this Privacy Policy, please contact us at <a href="mailto:support@payrendr.com" className="text-primary-600 hover:text-primary-700">support@payrendr.com</a>.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;